var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['avatar', _vm.size],style:({ backgroundImage: 'url(' + _vm.src + ')' })},[_vm._v(" "+_vm._s(_vm.userInitials)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }